import { Box, Heading, Text } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { GoShieldCheck } from 'react-icons/go'
import { LuFileCheck } from 'react-icons/lu'
import { useParams } from 'react-router-dom'
import { DescricaoCargo, NivelColaborador } from '../../../../interfaces'

import { appApi } from '../../../../services/appApi'

export const AssinaturaConfirmacao: React.FC = () => {
  const [Cargo, setCargo] = useState<DescricaoCargo>()
  const [isLoading, setIsLoading] = useState(false)

  const { documentoId } = useParams()
  const codigo = localStorage.getItem(`codigo-assinatura-cargosESalarios-${documentoId ?? ''}`)

  function criarNivelVazio(): NivelColaborador {
    return {
      conhecimentosTecnicos: [''],
      habilidades: [''],
      atribuicoes: [''],
      competenciasComportamentais: [''],
      primeiroQuartil: 0,
      mediana: 0,
      media: 0,
      terceiroQuartil: 0,
      criteriosPontuacao: []
    }
  }

  function GetDescritivo(): void {
    setIsLoading(true)

    appApi.post('api/CargosESalarios/GetPorIdAndCode', { Id: documentoId, codigo })
      .then((res) => {
        const data: DescricaoCargo = res.data

        if (Object.keys(data.niveis).length === 0) {
          let niveisGerados: Record<string, NivelColaborador> = {}

          if (data.tipoNivel === 'Júnior/Pleno/Sênior') {
            niveisGerados = {
              Júnior: criarNivelVazio(),
              Pleno: criarNivelVazio(),
              Sênior: criarNivelVazio()
            }
          }
          if (data.tipoNivel === 'I, II e III') {
            niveisGerados = {
              'Nível I': criarNivelVazio(),
              'Nível II': criarNivelVazio(),
              'Nível III': criarNivelVazio()
            }
          }
          if (data.tipoNivel === 'I, II, III, IV e V') {
            niveisGerados = {
              'Nível I': criarNivelVazio(),
              'Nível II': criarNivelVazio(),
              'Nível III': criarNivelVazio(),
              'Nível IV': criarNivelVazio(),
              'Nível V': criarNivelVazio()
            }
          }
          if (data.tipoNivel === 'Único') {
            niveisGerados = {
              Único: criarNivelVazio()
            }
          }

          data.niveis = niveisGerados
        }

        setCargo(data)
      })
      .catch(err => console.log(err))
      .finally(() => setIsLoading(false))
  }

  useEffect(() => {
    GetDescritivo()

    console.log(isLoading, Cargo)
  }, [])
  return (
        <Box bgColor={'white'} flex={1} flexDirection={'column'} display={'flex'} alignItems={'center'} pt={'2rem'}>
          {/* Circulo verde */}
          <Box bgColor={'green.300'} p={'1.2rem'} borderRadius={'full'} >
            <LuFileCheck size={50} color={'white'}/>
          </Box>
          <Heading fontWeight={'semibold'}>Tudo pronto!</Heading>
          <Box display={'flex'} flexDirection={'column'} alignItems={'center'} mt={'2rem'} fontSize={'2xl'} >
            <Text>O processo de alteração para <Text as={'span'} fontWeight={'bold'}>{Cargo?.nomeCargo}</Text> foi</Text>
            <Text>concluído e assinado digitalmente.</Text>
          </Box>
          {/* <Box display={'flex'}flexDirection={'row'} gap={'1.5rem'} mt={'1.5rem'} w={'800px'} justifyContent={'space-between'}>
            <Box textAlign={'left'} as='button' bgColor={'white'} color={'black'} display={'flex'} border={'2px solid'} borderColor={'blue.300'} borderRadius={'.40rem'} p={'1rem '} alignItems={'center'} gap={'1rem'}
             _hover={{ bgColor: 'blue.100' }}>
              <CiMail size={40} color={'blue'}/>
              <Box display={'flex'} flexDirection={'column'} gap={'0.3rem'} >
                <Text fontWeight={'semibold'} fontSize={'md'}>ENVIAR DOCUMENTO POR E-MAIL</Text>
                <Text fontSize={'sm'}>Receber cópia em PDF assinado</Text>
              </Box>
            </Box>
            <Box textAlign={'left'} as='button' bgColor={'white'} color={'black'} display={'flex'} border={'2px solid'} borderColor={'blue.300'} borderRadius={'.40rem'} p={'1rem '} alignItems={'center'} gap={'1rem'} w={'342.88px'} justifyContent={'center'}
            _hover={{ bgColor: 'blue.100' }}
            >
              <BsDownload size={40} color={'blue'}/>
              <Box display={'flex'} flexDirection={'column'} gap={'0.3rem'} >
                <Text fontWeight={'semibold'} fontSize={'md'}>BAIXAR DOCUMENTO</Text>
                <Text fontSize={'sm'}>Formato PDF assinado</Text>
              </Box>
            </Box>
          </Box> */}
          <Box bgColor={'blue.50'} display={'flex'} flexDirection={'row'} gap={'4rem'} borderRadius={'.40rem'} border={'2px solid'} borderColor={'blue.300'} w={'800px'} p={'1rem '} justifyContent={'space-between'} mt={'1rem'}>
            <Box display={'flex'} flexDirection={'column'} gap={'0.3rem'} >
              <Text color={'gray.500'} fontSize={'small'}>PROTOCOLO DE ASSINATURA</Text>
              <Text fontWeight={'semibold'}>{Cargo?.protocolo.protocoloId}</Text>
            </Box>
            <Box display={'flex'} gap={'0.5rem'} alignItems={'center'} bgColor={'white'} border={'2px solid'} borderColor={'gray.300'} p={'0.5rem'} borderRadius={'full'}>
              <GoShieldCheck size={20} color={'green'}/> <Text fontSize={'sm'}>Autentificado</Text>
            </Box>
          </Box>
        </Box>
  )
}
